module.exports = {
  title: '促销活动详情',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'time-limited-promotions-detail',
    },
  },
};
